export default __webpack_public_path__ + "locales/el-GR/PDFFormDialog.json?hash=f89c5403adc416e5e7a1eccc260d5e55";